// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgAdminSpaceMark24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.5 7C4.77614 7 5 6.77614 5 6.5C5 6.22386 4.77614 6 4.5 6C4.22386 6 4 6.22386 4 6.5C4 6.77614 4.22386 7 4.5 7ZM5.52719 8.77991C6.39559 8.38804 7 7.5146 7 6.5C7 5.11929 5.88071 4 4.5 4C3.11929 4 2 5.11929 2 6.5C2 7.31791 2.39278 8.04408 3 8.50018V20H21V8.50018C21.6072 8.04408 22 7.31791 22 6.5C22 5.11929 20.8807 4 19.5 4C18.1193 4 17 5.11929 17 6.5C17 7.5146 17.6044 8.38804 18.4728 8.77991L16 11.5L14.108 9.84453C14.3562 9.45629 14.5 8.99494 14.5 8.5C14.5 7.11929 13.3807 6 12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 8.99494 9.64383 9.45629 9.89197 9.84453L8 11.5L5.52719 8.77991ZM11.6383 10.974L7.84016 14.2974L5 11.1732V18H19V11.1732L16.1598 14.2974L12.3617 10.974C12.2436 10.9911 12.1228 11 12 11C11.8772 11 11.7564 10.9911 11.6383 10.974ZM12 9C12.2761 9 12.5 8.77614 12.5 8.5C12.5 8.22386 12.2761 8 12 8C11.7239 8 11.5 8.22386 11.5 8.5C11.5 8.77614 11.7239 9 12 9ZM20 6.5C20 6.77614 19.7761 7 19.5 7C19.2239 7 19 6.77614 19 6.5C19 6.22386 19.2239 6 19.5 6C19.7761 6 20 6.22386 20 6.5ZM12 13L13.4142 14.4142L12 15.8284L10.5858 14.4142L12 13Z"
				/>
			</Svg>
		);
	}
);
SvgAdminSpaceMark24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgAdminSpaceMark24;
